import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    findProductFromProductId,
    getAttributesSelectedFromFieldDataId,
} from "@qgiv/p2p-registration";
import {
    removeRegistrationStoreCartItem,
    selectAllRegistration,
} from "../../../../../redux/slices/registrationSlice";
import { selectAllProducts } from "../../../../../redux/slices/productsSlice";
import { selectBaseUrl } from "../../../../../redux/slices/p2pSettingsSlice";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import {
    setProductModalOpen,
    updateCurrentStoreCartItemIndex,
    updateOriginalStoreCartItemIndex,
} from "../../../../../redux/slices/productModalSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import { ThemeType } from "../../../../../redux/constants";
import StoreCartSummary from "./StoreCartSummary";

const ConnectedStoreCartSummary = ({ storeCartIndex }) => {
    const { storeCart = [] } = useSelector(selectAllRegistration);
    const products = useSelector(selectAllProducts);
    const baseUrl = useSelector(selectBaseUrl);
    const isCms = useSelector(selectIsCms);
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pActionSettings: {
            removeParticipantLinkLabel = "Remove",
            changeParticipantDetailsLinkLabel = "Change",
        },
    } = themeSettings;

    const storeItem = storeCart[storeCartIndex]
        ? storeCart[storeCartIndex]
        : {};

    const { Product_Id, Field_Data_Id = "", Product_Quantity } = storeItem;
    const productId = Product_Id;

    const { fieldDataObject } = getAttributesSelectedFromFieldDataId(
        Field_Data_Id,
        productId,
        products,
    );

    const attributeFieldValues =
        Field_Data_Id && Object.keys(fieldDataObject).length > 0
            ? fieldDataObject.fields
            : "";

    const productAttributes =
        attributeFieldValues && Object.keys(attributeFieldValues).length > 0
            ? Object.values(attributeFieldValues)
            : [];

    const productData = findProductFromProductId(productId, products);

    const { title, purchaseLimit } = productData;

    const formattedProductQuantity =
        Number(Product_Quantity) > 1 ? `x ${Product_Quantity}` : "";

    // Only display divider if more than one registration and it is not the last one
    const displayDivider = storeCart.length - 1 !== storeCartIndex;

    const isVisible = storeCart.length > 0;

    const displayChangeLink = !(
        purchaseLimit === 1 && productAttributes?.length === 0
    );

    const productName = title;

    const changeAriaLabel = `${changeParticipantDetailsLinkLabel} ${productAttributes} ${productName} quantity ${Product_Quantity}`;
    const removeAriaLabel = `${removeParticipantLinkLabel} ${productAttributes} ${productName} quantity ${Product_Quantity} from your cart.`;

    const storeCartSummaryProps = {
        baseUrl,
        displayChangeLink,
        Field_Data_Id,
        productId,
        productName,
        formattedProductQuantity,
        productAttributes,
        displayDivider,
        isCms,
        isVisible,
        storeCartIndex,
        changeAriaLabel,
        changeParticipantDetailsLinkLabel,
        removeAriaLabel,
        removeParticipantLinkLabel,
        // Actions
        removeRegistrationStoreCartItem,
        setProductModalOpen,
        updateCurrentStoreCartItemIndex,
        updateOriginalStoreCartItemIndex,
    };

    return <StoreCartSummary {...storeCartSummaryProps} />;
};

ConnectedStoreCartSummary.propTypes = {
    storeCartIndex: PropTypes.number.isRequired,
};

export default ConnectedStoreCartSummary;
